import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';

export interface OwnerDocument {
  type: string;
  number: string;
  masked?: string;
}

export interface Owner {
  fullname: string;
  document: OwnerDocument;
}

export interface Coverage {
  name: string;
  include?: boolean;
}

@Component({
  selector: 'app-summary-plan-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary-plan-card.component.html',
  styleUrl: './summary-plan-card.component.scss',
})
export class SummaryPlanCardComponent {
  planTitle = input<string>('');
  propertyAddress = input<string>('');
  propertyRegistration = input<string>('');
  owner = input<Owner | null>(null);
  tenant = input<Owner | null>(null);
  city = input<string>('');
  coverages = input<Coverage[]>([]);
  isCustomPlan = input<boolean>(false);
  paymentType = input<string>('');
  totalAmount = input(0);
  monthlyAmount = input(0);
  showDiscount = input(false);
  // Cuando llega, sustituye al SVG inline del header (los usos existentes no lo pasan y siguen viendo el SVG).
  imageSrc = input<string>('');

  isExpanded = signal(true);

  getDocumentType(type: string): string {
    const types: Record<string, string> = {
      C: 'C.C.',
      E: 'C.E.',
      P: 'P.',
    };
    return types[type] || type;
  }

  subtotalCalculated = computed(() => {
    if (this.paymentType() === 'Mensual') {
      return this.totalAmount() * 12;
    }
    return Math.ceil(this.totalAmount() / 0.8);
  });

  annualSaving = computed(() => this.subtotalCalculated() - this.totalAmount());

  formatPrice(value: number): string {
    return new Intl.NumberFormat('es-CO').format(value);
  }

  toggleExpanded(): void {
    this.isExpanded.update((v) => !v);
  }
}
